const orderListTable = [
  { selectAll: { label: false, admin: false, deletable: false } },
  {
    fullAddress: {
      label: "documentList.firstAddressline",
      admin: false,
      deletable: false
    }
  },
  { orderName: { label: "documentList.name", admin: false } },
  { creationDate: { label: "documentList.creationDate", admin: false } },
  { status: { label: "documentList.status", admin: false } },

  {
    accept: {
      label: "orderList.accept",
      admin: false,
      deletable: false,
      width: 130
    }
  },
  {
    cancel: {
      label: "orderList.cancel",
      admin: false,
      deletable: false,
      width: 130
    }
  },
  { PDF: { label: "orderList.pdf", admin: false } }
];

const runningTasksListTable = [
  { file: { label: "commandList.file", admin: false, deletable: false } },
  { status: { label: "commandList.status", admin: false } },
  { folder: { label: "commandList.folder", admin: false } },
  { submissionDate: { label: "commandList.submissionDate", admin: false } },
  { statusDate: { label: "commandList.statusDate", admin: false } },
  { producedDocumentCount: { label: "commandList.documents", admin: false } },
  { metadata: { label: "commandList.metadata", admin: false } },
  { showCommand: { label: "commandList.showCommand", admin: false } },
  { pomErrorCol: { label: "commandList.showPomError", admin: true } },
  { ownerLogin: { label: "commandList.ownerLogin", admin: true } },
  { dlPomOutputCol: { label: "commandList.downloadPomOutput", admin: true } },
  { dlSubmittedFile: { label: "commandList.submittedFile", admin: false } }
];

const documentListTable = [
  {
    fullAddress: {
      label: "documentList.firstAddressline",
      admin: false,
      deletable: false
    }
  },
  { creationDate: { label: "documentList.creationDate", admin: false } },
  { statusProd: { label: "documentList.status", admin: false } }
];

const letterListTable = [
  { selectAll: { label: false, admin: false, deletable: false } },
  {
    fullAddress: {
      label: "letterList.firstAddressline",
      admin: false,
      deletable: false
    }
  },
  { documentFileName: { label: "letterList.documentFileName", admin: false } },
  { status: { label: "letterList.statusString", admin: false } },
  { channel: { label: "letterList.channel", admin: false } },
  { pageCount: { label: "letterList.pageCount", admin: false } },
  {
    error: {
      label: "letterList.error",
      admin: false,
      deletable: false,
      end: true
    }
  },
  {
    PDF: {
      label: "orderList.pdf",
      admin: false,
      deletable: false,
      end: true,
      width: 100
    }
  }
];

const errorLetterListTable = [
  {
    fullAddress: {
      label: "letterList.firstAddressline",
      admin: false,
      deletable: false
    }
  },
  { error: { label: "letterList.error", admin: false, deletable: false } },
  { documentFileName: { label: "letterList.documentFileName", admin: false } },
  { status: { label: "letterList.status", admin: false } },
  {
    PDF: { label: "orderList.pdf", admin: false, deletable: false, width: 100 }
  }
];

const preprocessListTable = [
  {
    name: {
      label: "preprocessList.name",
      admin: false,
      deletable: false,
      width: 200
    }
  },
  {
    source_url: {
      label: "preprocessList.source",
      admin: false,
      deletable: true
    }
  },
  {
    target_url: {
      label: "preprocessList.destination",
      admin: false,
      deletable: true
    }
  },
  {
    patterns: {
      label: "preprocessList.patterns",
      admin: false,
      deletable: true,
      width: 100
    }
  },
  {
    cron: {
      label: "preprocessList.cron",
      admin: false,
      deletable: true,
      width: 100
    }
  },
  {
    last_execution_date: {
      label: "preprocessList.exec",
      admin: false,
      deletable: true,
      width: 200
    }
  },
  {
    actions: {
      label: "preprocessList.actions",
      admin: false,
      deletable: false,
      end: true,
      width: 120
    }
  }
];

export {
  orderListTable,
  runningTasksListTable,
  documentListTable,
  letterListTable,
  errorLetterListTable,
  preprocessListTable
};



// WEBPACK FOOTER //
// ./src/utils/tableConfig.js